import { Container } from "react-bootstrap"

const Term = () => {
  return(
    <Container className='term-page fade-in-text mt-5 mb-5'>
      <h1>Privacy Policy for Insale</h1>
      <p><strong>Effective Date:</strong> May 30, 2025</p>

      <p>Thank you for using Insale. This Privacy Policy describes how we collect, use, and protect your personal information when you use our application.</p>
      <br/>
      <h4>1. Information We Collect</h4>
      <h5>a. Personal Information</h5>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Login credentials</li>
        <li>Location (if you grant permission)</li>
      </ul>

      <h5>b. Usage Data</h5>
      <ul>
        <li>App usage activity</li>
        <li>Date and time of access</li>
        <li>Error reports and performance data</li>
      </ul>

      <h5>c. Device Information</h5>
      <ul>
        <li>Device type and operating system</li>
        <li>IP address</li>
        <li>Device identifiers</li>
      </ul>

      <h4>2. How We Use Your Information</h4>
      <ul>
        <li>To provide and improve our services</li>
        <li>To communicate important updates</li>
        <li>To offer customer support</li>
        <li>To comply with legal obligations</li>
      </ul>

      <h4>3. Information Sharing</h4>
      <p>We do <strong>not</strong> sell or rent your personal information. We may share data only with:</p>
      <ul>
        <li>Trusted service providers who support our app functionality</li>
        <li>Authorities when required by law</li>
        <li>Other parties with your explicit consent</li>
      </ul>

      <h4>4. Data Security & Retention</h4>
      <p>We implement appropriate security measures and retain your data only as long as necessary for the purposes described in this policy or as required by law.</p>

      <h4>5. Your Rights</h4>
      <p>You have the right to:</p>
      <ul>
        <li>Access and review your personal data</li>
        <li>Request corrections or deletions</li>
        <li>Withdraw consent where applicable</li>
        <li>Opt-out of non-essential communications</li>
      </ul>
      <p>To exercise your rights, please contact us at: <strong>sales@exel-int.com</strong></p>

      <h4>6. Permissions We Request</h4>
      <ul>
        <li><strong>Location</strong> {"\u2013"} to provide location-based features (if granted)</li>
        <li><strong>Notifications</strong> {"\u2013"} to inform you about important updates</li>
        <li>Other permissions will be explicitly requested in-app when required</li>
      </ul>

      <h4>7. Children's Privacy</h4>
      <p>Our app is not intended for children under the age of 13. We do not knowingly collect data from children.</p>

      <h4>8. Changes to This Policy</h4>
      <p>We may update this Privacy Policy from time to time. Changes will be notified via this page or in-app alerts.</p>

      <h4>9. Contact Us</h4>
      <p>If you have any questions about this Privacy Policy, please contact us:</p>
      <ul>
        <li><strong>App Name:</strong> Insale</li>
        <li><strong>Email:</strong> sales@exel-int.com</li>
        <li><strong>Developer:</strong> Exel Integrasi Solusindo</li>
      </ul>
    </Container>
  )
}

export default Term
